"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M21.29 6.75a.984.984 0 0 0-1.4 0l-.89.88.03-.56-3.46-3.48c-.38-.38-.89-.59-1.42-.59h-4.3c-.53 0-1.04.21-1.42.59L4.97 7.07l.03.5-.89-.87c-.39-.38-1.01-.38-1.39.01l-.02.02c-.38.39-.38 1.02.02 1.4L4.66 10h14.69l1.92-1.84c.4-.38.41-1.02.02-1.41m-15.5 11.4c.08 1.04.95 1.85 2 1.85h8.43c1.05 0 1.92-.81 1.99-1.85l.49-6.6H5.3z"
}), 'TakeoutDiningRounded');